/* template */
<template minapp="mpx" xlang="wxml"><es-layout custom-class="page" custom-main="custom-main" :layout="(['header'])" :esMainStyle="(esMainStyle)" navbarTitle="购票须知" :navbarStyle="(navbarStyle)" :useDefaultNavbar="(true)" :leftArrow="(true)"><div slot="header" class="fixed-nav"><div class="tab-bar"><mpx-view v-for="(item, index) in (tabs)" :key="item.index" @tap="handleTabClick(item.key)"><div :class="({'active': activeIndex === item.key })" class="tab-item">{{ item.text }}<div :class="({'item-slider-active':  activeIndex === item.key })" class="item-slider"></div></div></mpx-view></div></div><template v-for="(item, index) in (tabs)"><div class="content" v-if="(activeIndex === item.key)"><slot :name="('tab_' + item.key)"></slot></div></template></es-layout></template>

/* styles */
<style scoped lang="stylus" mpxStyleOptions='{"mid":"m074ce287"}'>
  .page
    box-sizing border-box
    height 100%
    overflow auto
    background linear-gradient(180deg, rgba(180, 210, 254, 0.8) 0%, rgba(248, 251, 255, 0.8) 81%, rgba(230, 237, 246, 0) 103%), linear-gradient(180deg, #FFFFFF 0%, #FFFFFF 78%, rgba(255, 255, 255, 0) 104%)
  .fixed-nav
    overflow-x scroll
    background-color #fff
    border-top solid 1px rgba(0, 0, 0, 0.08)
  .tab-bar
    background-color #fff
    left 0px
    top 0px
    height 48px
    width 450px
    opacity 1
    /* 自动布局 */
    display flex
    flex-direction row
    align-items center
    padding 12px 0px 0px 0px
    box-sizing border-box
    .tab-item
      margin-left 16px
      /* 自动布局子元素 */
      position static
      flex-shrink 0
      left 96px
      top 0px
      opacity 1
      font-family PingFangSC-Regular
      font-size 16px
      font-weight normal
      line-height 18px
      text-align center
      letter-spacing 0px
      color #000000
      display flex
      flex-direction column
      align-items center
    .item-slider
      width 32px
      height 3px
      border-radius 0.5px
      margin-top 14px
      opacity 1
    .item-slider-active
      background linear-gradient(270deg, #428EFF 0%, #1473FF 99%)
    .active
      color #1473FF
      font-family PingFangSC-Semibold
  .content
    padding 12px 12px 30px
    box-sizing border-box
</style>

/* json */
/* script */
<script>
  import processOption, { getComponent, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  const wxsModules = {}
  global.currentModuleId = "m074ce287"
  global.currentSrcMode = "wx"
  /** script content **/
  require("./tab-bar.mpx.js?isComponent&outputPath=components%2Ftab-bar074ce287%2Findex!=!@mpxjs/webpack-plugin/lib/selector?mode=web&env=!./tab-bar.mpx?ctorType=component&index=0&isComponent&mpx&outputPath=components%2Ftab-bar074ce287%2Findex&type=script")
  const currentOption = global.__mpxOptionsMap["m074ce287"]
  export default processOption(
    currentOption,
    "component",
    "",
    "components/tab-bar074ce287/index",
    {},
    // @ts-ignore
    {},
    // @ts-ignore
    {'warm-tips':getComponent(require("../../../components/warm-tips/index.mpx?isComponent&outputPath=components%2Findexfd0d1b18%2Findex")),'mpx-view':getComponent(require("@mpxjs/webpack-plugin/lib/runtime/components/web/mpx-view.vue?isComponent"), { __mpxBuiltIn: true })},
    undefined,
    {},
    undefined,
    getWxsMixin(wxsModules)
  )
</script>
